<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-11 14:52:20
-->
<template>
  <!-- 养成 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'egg' ? 'type-activite' : ''"
          @click="pageType = 'egg'"
        >
          投苗情况
        </div>
        <div
          :class="pageType === 'pond' ? 'type-activite' : ''"
          @click="pageType = 'pond'"
        >
          排塘情况
        </div>
      </div>
      <!-- 投卵情况 -->
      <EggPage v-if="pageType === 'egg'" />
      <!-- 排塘情况 -->
      <PondPage v-if="pageType === 'pond'" />
    </div>
  </div>
</template>

<script>
import EggPage from "./egg-page.vue";
import PondPage from "./pond-page.vue";
export default {
  name: "month-yc-put",
  data() {
    return {
      pageType: "egg",
    };
  },
  computed: {},
  methods: {},
  components: {
    EggPage,
    PondPage,
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
</style>